import Player from '@smart-tv/components/player/player';
import React from 'react';
import clsx from 'clsx';
import useVodPlayer from '../_hooks/use-vod-player';
import Portal from '@smart-tv/components/portal/portal';
import VodPlayerScreenInfo from './vod-player-screen-info';
import useVodPlayerScreen from './use-vod-player-screen';
import { useAtomValue } from 'jotai';
import { descalePlayerAtom } from '../../atoms';
import PlayerProductSheetInfo from '../../player-product-sheet-info/player-product-sheet-info';
import PlayerBackButton from '../../player-back-button';

import styles from './vod-player-screen.module.scss';

export const VodPlayerScreen: React.FC = () => {
  const { streamOptions } = useVodPlayer();
  const {
    sid = undefined,
    eventId = undefined,
    mediaId = undefined
  } = streamOptions?.streamParams ?? {};

  const descalePlayer = useAtomValue(descalePlayerAtom);

  const { handleBack } = useVodPlayerScreen();

  if (!streamOptions) return null;

  const rootClass = clsx(styles['vod-player-screen'], {
    [styles['vod-player-screen--descaled']]: descalePlayer
  });

  return (
    <Portal>
      <Player streamParams={streamOptions.streamParams} className={rootClass}>
        <PlayerBackButton onClick={handleBack} />
        <VodPlayerScreenInfo />
      </Player>
      {descalePlayer && <PlayerProductSheetInfo sid={sid} eventId={eventId} mediaId={mediaId} />}
    </Portal>
  );
};

export default React.memo(VodPlayerScreen);
